import type { FC } from "react";
import { Card } from "antd";

interface StatCardProps {
  label: string;
  value: string | number;
  description?: string;
}

const StatCard: FC<StatCardProps> = ({ label, value, description }) => (
  <Card className="stat-box">
    <div className="label">{label}</div>
    <div className="value">{value}</div>
    {description ? <div className="description">{description}</div> : null}
  </Card>
);

export default StatCard;
